import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language: any;
  supportedLanguage = environment.supported_language;
  private readonly _participantLocale = signal<any>('de-DE');
  private readonly _participantLocale$ = toObservable(this._participantLocale);
  private readonly _participantLanguage = signal<any>(environment.supported_language[1]);
  public shareParticipantLanguage = toObservable(this._participantLanguage);
  isNotparticipantSelectedLang:boolean = false;

  private readonly showLanguageSelectionPageState = signal<boolean>(false);
  public showLanguageSelectionPage$ = toObservable(this.showLanguageSelectionPageState);

  private readonly _isLanguageSelectionOpen = signal<boolean>(false);


  /**
   * @description This function is called from all routes and gives the user selected language from URL
   * Suppose, the user is in /register screen then the user will not have a language, in that case pick browser language
   * If language is present in URL
   * @returns language code
   */
  public getLanguage(): string {
    let defaultBrowserLanguage = navigator.language;
    let selectedLanguage:any = localStorage.getItem('language') ?? 'en-GB'; //languageId will get from url
    const currentUrl = window.location.href;

    const hasUserChangedLanguage = localStorage.getItem('languagePicked') === 'true';

     if (currentUrl.includes('/register') && !hasUserChangedLanguage) {
      defaultBrowserLanguage = defaultBrowserLanguage.split('-')[0]
      selectedLanguage = defaultBrowserLanguage;
    }

    const languageRegex: RegExp=/^[a-z]{2}-[A-Z]{2}$/

     const supportedLocales: any = {
      'en': 'en-GB',
      'de': 'de-DE',
      'fr': 'fr-FR',
      'it': 'it-IT',
      'ko': 'ko-KR',
      'cs': 'cs-CZ',
      'es': 'es-ES',
      'hr': 'hr-HR',
      'da': 'da-DK',
      'nl': 'nl-NL',
      'fi': 'fi-FI',
      'el': 'el-GR',
      'pl':'pl-PL',
      'ro': 'ro-RO',
      'sk' :'sk-SK',

    }

    if(languageRegex.test(selectedLanguage)) { //en-GB, //de-DE
      this.language = selectedLanguage;
    } else if(defaultBrowserLanguage && Object.keys(supportedLocales).includes(defaultBrowserLanguage)) { //system lang
      const selectedLang = (lang: string) => supportedLocales[lang];
      this.language = selectedLang(defaultBrowserLanguage);
    } else {
      this.language = environment.supported_language[0];  //en-GB
    }
    this._participantLocale.set(this.language);
    return this.language;
  }


  public set participantLocale(locale : string) {
    this._participantLocale.set(locale);
  }


  public get participantLocale() : any {
    return this._participantLocale$;
  }

  getDefaultLanguage() {
    const selectedLanguage = localStorage.getItem('language');
    const defaultBrowserLanguage = navigator.language;
    if(selectedLanguage && this.supportedLanguage.includes(selectedLanguage)) {
      this.language = selectedLanguage;
    } else if(defaultBrowserLanguage && this.supportedLanguage.includes(defaultBrowserLanguage)) {
      this.language = defaultBrowserLanguage;
    } else {
      this.language = environment.supported_language[0];
    }
    return this.language;
  }

  setParticipantLanguage(languageId: string) {
    this._participantLanguage.set(languageId);
  }

  setIsNotParticipantSelectedLang(status: boolean) {
    this.isNotparticipantSelectedLang = status;
  }
  getIsNotParticipantSelectedLang() {
    return this.isNotparticipantSelectedLang;
  }

  /**
   * @description This method is used to check the language is valid or not
   * Match the pattern of language en-GB, en-IN, de-DE, fr-FR, it-IT, es-ES, cs-CZ, ko-KR
   * @param locale
   * @returns
   */
  public checkIsValideLanguage(locale: any): boolean {
    const languageRegex: RegExp = /^[a-z]{2}-[A-Z]{2}$/;
    const isValid = languageRegex.test(locale);
    return isValid;
  }

  public showLanguageSelectionPage(showLangPage: boolean){
    this.showLanguageSelectionPageState.set(showLangPage);
  }

  public setIsLanguageSelectionOpen(isOpen: any) {
    this._isLanguageSelectionOpen.update(() => isOpen);
  }

  public getIsLanguageSelectionOpen() {
    return this._isLanguageSelectionOpen();
  }

}
